<template>
  <div>
    <div>
      <v-layout wrap>
        <v-flex xs9 class="pl-2">
          <h1 style="color: #66a6fe">
            Chatday By
            <img src="/static/img/readyplanet.png" style="height: 25px" />
            <v-chip color="red" class="white--text" disabled small>{{ $t('New') }}</v-chip>
          </h1>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn v-if="!isEdit" icon outline color="primary" @click="isEdit = !isEdit">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="pl-2">
          <ul class="list-group vertical-steps">
            <li class="list-group-item">
              สร้างแชทบอทได้บนเว็บไซต์ เพียงลงทะเบียนเปิดบัญชีกับระบบ Chatday สมัครฟรีวันนี้
              <div>
                <v-btn
                  class="py-2"
                  color="primary"
                  depressed
                  style="display: inline-block"
                  href="https://www.readyplanet.com/17331353/readyplanet-marketing-platform?utm_source=zwiz&utm_medium=referral&utm_campaign=<chatday>"
                  target="_BLANK"
                  >{{ $t('Register CHATDAY') }}</v-btn
                >
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-control" :class="{ 'has-error': errors.has('token') }">
                <label for="text">{{ $t('Token') }}</label>
                <div v-if="isEdit">
                  <textarea
                    v-model="token"
                    v-validate="{ required: true }"
                    class="form-control"
                    rows="5"
                    maxlength="600"
                    style="resize: vertical; min-height: 90px"
                    :data-vv-as="$t('Token')"
                    name="token"
                    :placeholder="'Token'"
                  ></textarea>

                  <span v-if="errors.has('token')" class="text-error">
                    {{ errors.first('token') }}
                  </span>
                </div>
                <div v-else>
                  <div class="primary--text" style="word-break: break-all">
                    {{ token ? token : '-' }}
                  </div>
                </div>
                <div v-if="isEdit" class="text-xs-center" style="margin-top: 15px">
                  <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
                  <v-btn color="primary" @click="saveEdit">{{ $t('Save') }}</v-btn>
                </div>
              </div>
            </li>
            <li v-if="token" class="list-group-item">
              <div>
                <label for>Webhook Url</label>
                <textarea
                  class="form-control"
                  style="resize: vertical; min-height: 90px; background: #eee"
                  onclick="this.select()"
                  readonly="true"
                >
                    https://zwizai.herokuapp.com/webhookreadyplanet
                    </textarea
                >
              </div>
            </li>
          </ul>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      isEdit: false,
      token: ''
    }
  },
  mounted() {
    this.token = this.selectedBot.chatday_token
    if (this.token == null || this.token == '') {
      this.isEdit = true
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    cancelEdit() {
      this.token = this.selectedBot.chatday_token
      this.isEdit = false
    },
    async saveEdit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }

      let status = await this.checkChatdayToken()
      if (status) {
        this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })
        this.isEdit = false
      } else {
        this.$swal.fire({
          title: this.$t('Unsuccessful'),
          type: 'error'
        })
      }
    },
    checkChatdayToken() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          chatday_token: vm.token
        }
        api.checkChatdayToken(data, (error, response) => {
          if (error) reject(error)

          if (response.responsecode == 200 && response.status == 'pass') resolve(true)
          else resolve(false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Chatday.vue